var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.667 8.333a1 1 0 0 0-2 0 4.333 4.333 0 1 0 8.666 0 1 1 0 1 0-2 0 2.333 2.333 0 1 1-4.666 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.104 1.19a1.32 1.32 0 0 1 1.05-.52h9.692c.412 0 .8.193 1.05.52l1.89 2.481c.463.61.714 1.354.714 2.119V16.7a2.64 2.64 0 0 1-2.64 2.64H4.14A2.64 2.64 0 0 1 1.5 16.7V5.79c0-.765.251-1.51.715-2.119zM3.5 16.7V6h13v10.7a.64.64 0 0 1-.64.64H4.14a.64.64 0 0 1-.64-.64",
  clipRule: "evenodd"
})));
SvgShoppingBag.displayName = "SvgShoppingBag";
export { SvgShoppingBag as ReactComponent };
export default SvgShoppingBag;